export const featuredTestimonials = [
  {
    initials: 'MR',
    text: 'Mi ha fatto risparmiare un sacco di tempo. Il lunedì arrivo in palestra già pronto, senza corse dell’ultimo minuto. Lo consiglio davvero.',
    author: 'Marco R.',
    role: 'Coach Funzionale · Milano',
    bg: 'bg-blue-600',
  },
  {
    initials: 'CB',
    text: 'Prima di comprarlo avevo qualche dubbio, ma mi ha sorpresa. Con le tre versioni gestisco gruppi di livello misto senza alcuno stress.',
    author: 'Chiara B.',
    role: 'Istruttrice · Bologna',
    bg: 'bg-cyan-600',
  },
  {
    initials: 'DG',
    text: 'Preparo una lezione in 10 minuti e si vede. Per quello che costa, lo consiglio senza pensarci due volte.',
    author: 'Davide G.',
    role: 'Coach di Boxe · Roma',
    bg: 'bg-blue-600',
  },
]

export const coachTestimonials = [
  {
    initials: 'LM',
    name: 'Laura M.',
    location: 'Torino',
    text: 'Arrivavo al lunedì sfinita. Ora apro il volume e in 5 minuti la mia lezione è pronta.',
    bg: 'bg-blue-600',
  },
  {
    initials: 'GP',
    name: 'Giuseppe P.',
    location: 'Napoli',
    text: 'L’ho comprato un po’ scettico e mi ha sorpreso: è molto più completo di quanto mi aspettassi.',
    bg: 'bg-cyan-600',
  },
  {
    initials: 'FR',
    name: 'Francesca R.',
    location: 'Firenze',
    text: 'I riscaldamenti e le chiusure mi hanno salvata. Si vede che ogni lezione ha una struttura dall’inizio alla fine.',
    bg: 'bg-blue-600',
  },
  {
    initials: 'AF',
    name: 'Alessandro F.',
    location: 'Verona',
    text: 'Mi ha fatto risparmiare tantissimo tempo. Non perdo più le domeniche a costruire sessioni. Consigliatissimo.',
    bg: 'bg-cyan-600',
  },
]
